const EPG_DAY_RANGE_DEFAULTS = { daysBefore: 1, daysAfter: 2 } as const;

/** Under this, a foreground keeps the user's scroll (KAHI-174); over it the EPG re-anchors and refetches (KAHI-264). */
export const EPG_REANCHOR_AFTER_BACKGROUND_MS = 5 * 60 * 1000;

export default EPG_DAY_RANGE_DEFAULTS;
